import User from './User';

export class Learner extends User {
  static get entity() {
    return 'learners';
  }

  static get fk() {
    return 'learner';
  }

  static fields() {
    return {
      id: this.attr(null),
      firstname: this.attr(null),
      lastname: this.attr(null),
      username: this.attr(null),
      user_roles: this.attr([]),
      uid: this.attr(null),
      jwt_token: this.attr(null),
      email: this.attr(null),
      description: this.attr(null),
      auth_source: this.attr(null),
      learning_units: this.attr([]),
      user_enrollments: this.attr([]),
      sections: this.attr([]),
      date_of_birth: this.attr(null),
      phone_number: this.attr(null),
      current_occupation: this.attr(null),
      desired_occupation: this.attr(null),
      area_of_employment: this.attr(null),
      experience_level: this.attr(null),
      education_level: this.attr(null),
      goals: this.attr(null),
      like_to_learn: this.attr(null),
      know_us_from: this.attr(null),
      interested_micro_credentials: this.attr(null),
      confirmed: this.attr(false),
      profile_picture: this.attr([])
    };
  }

  static apiConfig = {
    actions: {
      ...User.apiConfig?.actions,

      findOneLearner(learnerId) {
        return this.get(`/utilities/learner/${learnerId}`);
      },

      findLearnersByLearningUnitId(learningUnitId, modes) {
        return this.get(`/applications/learning-units/${learningUnitId}`, {
          params: {
            modes
          }
        });
      }
    }
  };
}

export default Learner;
